module.exports = __webpack_public_path__ + "static/img/02_active.60f538d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact/02_active.png
// module id = owyo
// module chunks = 1